(() => {
  angular
    .module('gm.common.directives')
    .directive('gmPhoneInput', gmPhoneInputDirective);

  function gmPhoneInputDirective(
    $filter,
    Countries,
    GmyPhone
  ) {
    'ngInject';

    return {
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        country: '=',
        placeholder: '@',
        tip: '@?',
        countryReadonly: '@'
      },
      templateUrl: 'modules/common/directives/phone-input/phone-input.html',
      transclude: true,
      link(scope, _element, _attrs, ctrl) {
        const countryList = Countries.filter(c => !!c.key).map(prepareCountryForDropdownMeny);

        function prepareCountryForDropdownMeny(c) {
          return {
            id: c.key.toUpperCase(),
            name: c.country,
            meta: `+${c.code}`,
            flag: c.key ? c.key.toLowerCase() : null,
            code: c.code
          };
        }

        scope.$sc = scope;
        scope.filterInput = '';
        scope.filteredCountries = [];

        scope.$watch('filterInput', (filterInput) => {
          scope.filteredCountries = $filter('filter')(countryList, filterInput);
        });

        scope.activeCountry = null;
        scope.phoneNumber = '';

        scope.$watch(() => ctrl.$viewValue, (val) => {
          if (val) {
            if (GmyPhone.isValidPhoneNumber(val, scope.countryReadonly ? scope.country : null)) {
              const countryCode = GmyPhone.getPhoneCountryCode(val);
              const phoneNumberWithoutCountryCode = GmyPhone.getPhoneWithoutCountryCode(val);

              if (scope.country !== countryCode) {
                scope.country = countryCode;
              }

              if (scope.phoneNumber !== phoneNumberWithoutCountryCode) {
                scope.phoneNumber = phoneNumberWithoutCountryCode;
              }
            } else {
              ctrl.$viewValue = null;
            }
          }
        });

        scope.$watch('country', (countryCode) => {
          scope.activeCountry = countryList.find(c => c.id === countryCode);
        });

        scope.$watchGroup(['phoneNumber', 'activeCountry.code'], ([number, code]) => {
          if (number && code) {
            const cleanedNumber = GmyPhone.formatPhoneNumber(
              `+${code}${number}`,
              scope.countryReadonly ? scope.country : null
            );

            if (cleanedNumber) {
              ctrl.$setViewValue(cleanedNumber);

              return;
            }
          }

          if (ctrl.$viewValue) {
            ctrl.$setViewValue(null);
          }
        });

        scope.setActiveCountry = (code) => {
          scope.country = code;
        };
      },
    };
  }
})();
